import { ApiAction, ApiItemType } from '@highimpact-frontend/api-types';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React from 'react';

export type MUITabItemSettings = {
  children: React.ReactNode;
  label: string;
  itemName?: ApiItemType;
  action?: ApiAction;
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface TabComponentProps {
  tabs: MUITabItemSettings[];
  storageKey: string;
}

function TabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

//creates aria attributes for tabs in MUI to improve accessibility (a11y)
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabComponent({
  tabs,
  storageKey
}: TabComponentProps) {
  
  const storedIndex = Number(localStorage.getItem(storageKey));
  const [value, setValue] = React.useState(storedIndex ?? 0);  

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    localStorage.setItem(storageKey, String(newValue));
  };
    
  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="Basic MUI Tabs">
          {tabs.map((tab, index) =>            
            <Tab
              key={index}
              label={tab.label}
              disabled={tab.action === "disable"}
              {...a11yProps(index)}              
            />           
          )}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <TabPanel 
          key={index} 
          value={value} 
          index={index}          
        >
          {tab.action === "hide_with_message"
            ? <div>Vous n'avez pas les permissions nécessaires…</div>
            : tab.children
          }
        </TabPanel>
      ))}
    </Box>
  );
}

export default TabComponent;
